import Toggle from "core/components/Toggle";
import Typography from "core/components/Typography";
import ButtonLink from "core/components/ButtonLink";
import styled from "styled-components";
import useBundleFilters from "core/hooks/useBundleFilters";
import { AnimatePresence, LayoutGroup, motion } from "framer-motion";
import { PRODUCT_BUNDLES } from "./constants";
import { PRODUCTS } from "modules/admin/OrgProductLicenseForm";

const BundleCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: fit-content;
  margin-bottom: 24px;
`;

const ProductBundle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ProductBundleItems = styled.div`
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
`;

const ProductItem = styled.div`
  padding: 16px;
  max-height: 80px;
  min-width: 285px;
  border-radius: 5px;
  border: 1px solid #979797;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ProductActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 24px;
  gap: 8px;
`;

const ProductBundleCard = ({
  preparedUpdates,
  productsEnabled,
  handleProductToggle,
  isReadOnly,
}) => {
  const { selectedBundles, visibleProducts } = useBundleFilters();

  return (
    <>
      <BundleCard>
        {selectedBundles.map((bundle) => {
          return (
            <motion.div
              key={bundle.id}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.35, ease: "easeInOut" }}
              layout
            >
              <ProductBundle key={bundle.id}>
                <Typography variant="h4" noMargin>
                  {bundle.name}
                </Typography>
                <ProductBundleItems>
                  {visibleProducts
                    .filter((product) => product.meta.bundle.id === bundle.id)
                    .map((product) => {
                      const isDirty =
                        preparedUpdates &&
                        Object.keys(preparedUpdates).includes(product?.id);

                      return (
                        <ProductItem key={product?.id}>
                          <div
                            style={{
                              fontSize: 16,
                              fontWeight: 700,
                              color: "#000000",
                            }}
                          >
                            {product?.meta?.name}
                          </div>
                          <ProductActions>
                            <ButtonLink
                              to={`../${bundle.path}/${product.page.path}`}
                              variant="text"
                              size="small"
                              data-test="configure-button"
                            >
                              {isDirty ? "Edit" : "Configure"}
                            </ButtonLink>
                            <Toggle
                              id={product?.id}
                              value={productsEnabled.includes(product.id)}
                              onChange={(isChecked) =>
                                handleProductToggle(product?.id, isChecked)
                              }
                              isDisabled={isReadOnly}
                              dataTest="toggle-button"
                              labelPosition="left"
                            />
                          </ProductActions>
                        </ProductItem>
                      );
                    })}
                </ProductBundleItems>
              </ProductBundle>
            </motion.div>
          );
        })}
      </BundleCard>
    </>
  );
};

export default ProductBundleCard;
